<div class="clearfix">
  <div class="md-col md-col-6">
    <app-element-select
      [options]="persons"
      [displayLabel]="'Filter documents by Person'"
      [customCssClasses]="['w-50']"
      [emitNameValueDTO]="true"
      (selectionChanged)="onPersonFilterChange($event)">
    </app-element-select>
  </div>
  
  <div class="md-col md-col-6 flex justify-content-end">
    <button color="accent" mat-raised-button
            (click)="openUploadDialog()">
      <mat-icon>upload_file</mat-icon>
      Upload Document
    </button>
  </div>
</div>


<ng-container *ngIf="dataSource?.data?.length > 0; then showDocuments else emptyDocumentsTable"></ng-container>
<ng-template #showDocuments>
  <div class="mat-elevation-z8 table-container">
    <table [dataSource]="dataSource" mat-table>
      <!-- Person Column -->
      <ng-container [matColumnDef]="tableColumns.Person">
        <th *matHeaderCellDef mat-header-cell>Person</th>
        <td *matCellDef="let element" mat-cell>{{element.person}}</td>
      </ng-container>
      
      <!-- Document Type Column -->
      <ng-container [matColumnDef]="tableColumns.DocumentType">
        <th *matHeaderCellDef mat-header-cell>Document Type</th>
        <td *matCellDef="let element" mat-cell>{{element.documentTypeCode}}</td>
      </ng-container>
      
      <!-- Reference Number Column -->
      <ng-container [matColumnDef]="tableColumns.ReferenceNumber">
        <th *matHeaderCellDef mat-header-cell>Reference Number</th>
        <td *matCellDef="let element" mat-cell>{{element.documentReferenceNumber}}</td>
      </ng-container>
      
      <!-- Actions Column -->
      <ng-container [matColumnDef]="tableColumns.Actions">
        <th *matHeaderCellDef mat-header-cell>Actions</th>
        <td *matCellDef="let element" mat-cell>
          <button color="primary" mat-icon-button
                  (click)="onClickDownloadDocument(element.documentReferenceNumber)">
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <ng-container *ngIf="element.isPersonDocument">
            <button mat-icon-button color="primary" (click)="onDeleteDocument(element)" matTooltip="Delete Document">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>
      
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
    
    <mat-paginator [pageSizeOptions]="pageSizeOptions"
                   [pageSize]="pageSizeOptions[0]"
                   [length]="dataSource.data.length">
    </mat-paginator>
  </div>
</ng-template>

<ng-template #emptyDocumentsTable>
  <div class="text-center">
    <label class="column-label mt2 mb2">No documents found</label>
  </div>
</ng-template>
